export type TimerCompletionResourceType = 'schedule' | 'narrative';

export interface TimerCompletionDetail {
  timerId: string | number;
  completionKey?: string;
  sessionId?: string;
}

const ACK_PREFIX = 'timer-completion-ack:';

export function getTimerCompletionKey(detail: TimerCompletionDetail): string | null {
  if (!detail.completionKey) return null;
  return `${String(detail.timerId)}:${detail.completionKey}`;
}

export function hasAcknowledgedTimerCompletion(completionKey: string): boolean {
  try {
    return sessionStorage.getItem(`${ACK_PREFIX}${completionKey}`) === '1';
  } catch {
    return false;
  }
}

export function acknowledgeTimerCompletion(completionKey: string): void {
  try {
    sessionStorage.setItem(`${ACK_PREFIX}${completionKey}`, '1');
  } catch {
    // Storage may be unavailable in private or restricted browser contexts.
  }
}

export function isValidTimerCompletionResource(
  type: string | null | undefined,
  id: string | null | undefined,
): type is TimerCompletionResourceType {
  return Boolean(id && (type === 'schedule' || type === 'narrative'));
}

export function getNormalTimerCompletionPath(
  hubId: string,
  type: string | null | undefined,
  id: string | null | undefined,
): string | null {
  if (!isValidTimerCompletionResource(type, id)) return null;

  if (type === 'schedule') {
    return `/hub/${hubId}/schedules?scheduleId=${encodeURIComponent(id)}`;
  }

  return `/hub/${hubId}/social-narratives?resourceId=${encodeURIComponent(id)}`;
}